import { getPointColor, getPointIcon, getTimelinePoints } from '@/components/services/report-manager/commons/timeline/utils'

import render from './render'

export default {
  name: 'Timeline',

  props: {
    value: {
      type: Object,
      default: undefined
    },

    service: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      timelinePoints: []
    }
  },

  mounted() {
    this.timelinePoints = this.getTimelinePoints(this.value, this.service)
  },

  methods: {
    getTimelinePoints,
    getPointColor,
    getPointIcon
  },

  render
}

